import type { YesNo } from "../../hooks/useLeadFormState";

export default function ServicesStep({
  needsFinancingQuestion,
  needsTradeInQuestion,
  wantsFinancing,
  hasTradeIn,
  setWantsFinancing,
  setHasTradeIn,
  onSubmit,
  onBack,
}: {
  needsFinancingQuestion: boolean;
  needsTradeInQuestion: boolean;
  wantsFinancing: YesNo;
  hasTradeIn: YesNo;
  setWantsFinancing: (v: YesNo) => void;
  setHasTradeIn: (v: YesNo) => void;
  onSubmit: () => void;
  onBack: () => void;
}) {
  return (
    <div>
      <p className="tdb-timeTitle">Quelques questions pour mieux vous aider</p>

      <div className="tdb-fields">
        {needsFinancingQuestion && (
          <div className="tdb-field" style={{ alignItems: "flex-start" }}>
            <div style={{ width: "100%" }}>
              <div
                style={{
                  marginBottom: 10,
                  fontWeight: 600,
                  fontSize: 12,
                  maxWidth: "90%",
                }}
              >
                Souhaitez-vous une proposition de financement ?
              </div>

              <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
                <label
                  style={{
                    display: "flex",
                    gap: 8,
                    alignItems: "center",
                    fontSize: 12,
                  }}
                >
                  <input
                    type="radio"
                    name="wantsFinancing"
                    style={{ accentColor: "black", margin: 0 }}
                    checked={wantsFinancing === "yes"}
                    onChange={() => setWantsFinancing("yes")}
                  />
                  Oui
                </label>

                <label
                  style={{
                    display: "flex",
                    gap: 8,
                    alignItems: "center",
                    fontSize: 12,
                  }}
                >
                  <input
                    type="radio"
                    name="wantsFinancing"
                    style={{ accentColor: "black", margin: 0 }}
                    checked={wantsFinancing === "no"}
                    onChange={() => setWantsFinancing("no")}
                  />
                  Non
                </label>
              </div>
            </div>
          </div>
        )}

        {needsTradeInQuestion && (
          <div className="tdb-field" style={{ alignItems: "flex-start" }}>
            <div style={{ width: "100%" }}>
              <div style={{ marginBottom: 10, fontWeight: 600, fontSize: 12 }}>
                Avez-vous un véhicule à faire reprendre ?
              </div>

              <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
                <label
                  style={{
                    display: "flex",
                    gap: 8,
                    alignItems: "center",
                    fontSize: 12,
                  }}
                >
                  <input
                    type="radio"
                    name="hasTradeIn"
                    style={{ accentColor: "black", margin: 0 }}
                    checked={hasTradeIn === "yes"}
                    onChange={() => setHasTradeIn("yes")}
                  />
                  Oui
                </label>

                <label
                  style={{
                    display: "flex",
                    gap: 8,
                    alignItems: "center",
                    fontSize: 12,
                  }}
                >
                  <input
                    type="radio"
                    name="hasTradeIn"
                    style={{ accentColor: "black", margin: 0 }}
                    checked={hasTradeIn === "no"}
                    onChange={() => setHasTradeIn("no")}
                  />
                  Non
                </label>
              </div>
            </div>
          </div>
        )}
      </div>

      <button
        type="button"
        onClick={onSubmit}
        disabled={
          (needsFinancingQuestion && !wantsFinancing) ||
          (needsTradeInQuestion && !hasTradeIn)
        }
        className="tdb-primaryBtn"
      >
        Envoyer ma demande
      </button>

      <button type="button" onClick={onBack} className="tdb-linkBtn">
        ← Retour
      </button>
    </div>
  );
}
